import { Injectable } from "@angular/core";
import { Observable, Subscription } from "rxjs";
// import { RequestAddBankDto, RequestBankGetHistoryDto, RequestEditBankDto, ResponseBankAccountGetHistoryDto, ResponseGetBankMultipleDto } from "../../../../shared/nestjs/gd-only/dto/multibank.dto";
import { NestResponsesProvider } from "../../../../shared/nestjs/nest-responses";
import { NestApiProvider } from "../../../../shared/nestjs/nest-api";
import { PersonalNestApi } from "../../../../shared/nestjs/gd-only/services/personal.api";
import { GlobalServiceProvider } from "../../../../providers/global-service/global-service";
import { LangskillSf6Api } from "../../../../shared/nestjs/gd-integrated/services/langskill.api";
import { ResponseAddDto, ResponseDeleteDto } from "../../../../shared/nestjs/gd-integrated/dto/langskill.dto";
import { ResponseSaveDto } from "../../../../shared/nestjs/gd-integrated/dto/letter.dto";

@Injectable()
export class ProfileLangSkillBloc {

  subscriptions: Array<Subscription> = [];

  constructor(
    public nestResponse: NestResponsesProvider,
    public nestApiProvider: NestApiProvider,
    public personalApi: PersonalNestApi,    
    public globalService: GlobalServiceProvider,
    public langskillSf6Api: LangskillSf6Api    
  ) { 
  }

  listing(payload): Observable<any> {
		return this.langskillSf6Api.listing(
			payload.empId
		);
	}

	add(data): Observable<ResponseAddDto> {
		return this.langskillSf6Api.add(data);
	}

	save(data): Observable<ResponseSaveDto> {
		return this.langskillSf6Api.save(data);
	}

	delete(data): Observable<ResponseDeleteDto> {
		return this.langskillSf6Api.delete(data);
  }

  getPersonal(payload): Promise<any> {
    return new Promise((resolve, reject) => {
      this.personalApi.getPersonal(payload).subscribe(
        async (result) => {
          console.log('BLOC | getPersonal', result)
          let resultData = await this.globalService.convertObjToCamelCase(result.data);
          console.log('BLOC | resultData', resultData)
          resolve(resultData);
        }, error => {
          reject(error);
          console.log('getPersonal', error)
        }
      )
    })
  }

  language(): Observable<any> {
    return this.langskillSf6Api.language();
  }

  dispose() {
    this.subscriptions.forEach((sub) => sub.unsubscribe);
  }
}


// WEBPACK FOOTER //
// ./src/bloc/feature/profile/profile-langskill/profile-langskill.bloc.ts